import { Suspense, lazy, useEffect } from 'react'
import { ToastContainer } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { Route, Routes, useNavigate, useLocation, useMatch, Navigate } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import 'react-loading-skeleton/dist/skeleton.css';
import { LoadScript } from '@react-google-maps/api';
import { google_map_api_keys, userId } from './utils/constants';
import * as AuthActions from './redux/actions/authAction';
import * as SancharActions from './redux/actions/sancharAction';

// TODO : Components
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import Loading from './components/features/Loading';
import ProtectedRoute from './utils/protected-routes';
import LoginModal from './components/modal/LoginModal';
import SignupModal from './components/modal/SignupModal';
import ComingSoon from './components/features/ComingSoon';
import ScrollToTop from './components/features/ScrollToTop';
import DownloadApp from './components/features/DownloadApp';

// TODO: Milan Sathi Start
import VerifyEmailPage from "./pages/VerifyEmailPage"
import { useAuth } from './contexts/AuthContext';
import Breadcrumbs from './components/common/Breadcrumbs';
import MilanSathiHeader from './components/common/MilanSathiHeader';
import AutoTranslator from './components/common/AutoTranslator';
// Todo : Milan Sathi Updated
const MilanSathi = lazy(() => import('./pages/milan-sathi'));
const Search = lazy(() => import('./pages/milan-sathi/search'));
const Profile = lazy(() => import('./pages/milan-sathi/search/profile'));
const Membership = lazy(() => import('./pages/milan-sathi/membership'));
const Checkout = lazy(() => import('./pages/milan-sathi/check-out'));

//! Dashboard
const Dashboard = lazy(() => import('./pages/dashboard'));
const Connections = lazy(() => import('./pages/dashboard/connections'));
const Messages = lazy(() => import('./pages/dashboard/messages'));
const Conversations = lazy(() => import('./pages/dashboard/messages/conversations'));
const EditProfile = lazy(() => import('./pages/dashboard/edit-profile'));
const Verification = lazy(() => import('./pages/dashboard/verification'));
const Transactions = lazy(() => import('./pages/dashboard/transactions'));
const Notifications = lazy(() => import('./pages/dashboard/notifications'));

//! Lazy Load Pages
//* History
const RechargeHistory = lazy(() => import('./pages/history/recharge-history'));
const ProductHistory = lazy(() => import('./pages/history/product-history'));
const PujaHistory = lazy(() => import('./pages/history/puja-history'));
const YatraHistory = lazy(() => import('./pages/history/yatra-history'));
const PitrPakshaHistory = lazy(() => import('./pages/history/pitr-paksha'));
const NewYatraHistory = lazy(() => import('./pages/history/newyatra-history'));
const BharatDarshanProfile = lazy(() => import('./pages/profile'));

const LandingPage = lazy(() => import('./pages/landing-page'));
const Formdata = lazy(() => import('./pages/landing-page/form-data'));
const Vsscm = lazy(() => import('./pages/vsscm'));
const FlightsBooking = lazy(() => import('./pages/flights-booking'));
const Mobile = lazy(() => import('./pages/mobile'));
const Recharge = lazy(() => import('./pages/recharge'));

//* Sanchar
const SancharPodcast = lazy(() => import('./pages/sanchar/podcast'));
const SancharPodcastdata = lazy(() => import('./pages/sanchar/podcast/podcast-data'));
const SancharVideo = lazy(() => import('./pages/sanchar/video'));
const SancharVideodata = lazy(() => import('./pages/sanchar/video/video-data'));
const SancharLive = lazy(() => import('./pages/sanchar/live'));
const SancharLiveDetails = lazy(() => import('./pages/sanchar/live/live-details'));
const SancharNews = lazy(() => import('./pages/sanchar/news'));
const SancharNewsDetails = lazy(() => import('./pages/sanchar/news/news-details'));

//* Religious
const DailyDarshan = lazy(() => import('./pages/religious/daily-darshan'));
const Consultancy = lazy(() => import('./pages/religious/consultancy'));

//* Yatra
const Yatra = lazy(() => import('./pages/ecommerce/yatra'));
const YatraChild = lazy(() => import('./pages/ecommerce/yatra/yatra-child'));
const YatraDetails = lazy(() => import('./pages/ecommerce/yatra/yatra-details'));
const BookYatra = lazy(() => import('./pages/ecommerce/yatra/book-yatra'));

//* New Yatra
const NewYatraList = lazy(() => import('./pages/new-yatra'));
const NewYatraDetails = lazy(() => import('./pages/new-yatra/details'));
const NewYatraPackage = lazy(() => import('./pages/new-yatra/package'));
const NewYatraVehicle = lazy(() => import('./pages/new-yatra/vehicle'));
const NewYatraBooking = lazy(() => import('./pages/new-yatra/booking'));
const NewYatraPaymentSuccess = lazy(() => import('./pages/new-yatra/payment-success'));
const NewYatraPaymentFailed = lazy(() => import('./pages/new-yatra/payment-failed'));

//* Products
const Products = lazy(() => import('./pages/ecommerce/products'));
const ProductDetails = lazy(() => import('./pages/ecommerce/products/product-details'));
const ProductsCart = lazy(() => import('./pages/cart/products-cart'));
const Address = lazy(() => import('./pages/cart/address'));
const PaymentStatus = lazy(() => import('./pages/payment-status'));

//* Puja
const Puja = lazy(() => import('./pages/ecommerce/puja'));
const PujaDetails = lazy(() => import('./pages/ecommerce/puja/puja-details'));
const BookPuja = lazy(() => import('./pages/ecommerce/puja/book-puja'));

//! Static Page 
const TermsOfUse = lazy(() => import('./pages/static-page/terms-of-use'));
const PrivacyPolicy = lazy(() => import('./pages/static-page/privacy-policy'));
const RefundPolicy = lazy(() => import('./pages/static-page/refund-policy'));
const AboutUs = lazy(() => import('./pages/static-page/about-us'));

const CustomLogin = lazy(() => import('./pages/custom-login'));

// TBO Flight
const TBOFlightSearch = lazy(() => import('./pages/tbo/flight-search'));
const TBOFlightList = lazy(() => import('./pages/tbo/flight-list'));
const TBOFlightDetails = lazy(() => import('./pages/tbo/flight-details'));
const TBOPassengerDetails = lazy(() => import('./pages/tbo/passenger-details'));
const TBOFlightPayment = lazy(() => import('./pages/tbo/flight-payment'));
const TBOFlightHistory = lazy(() => import('./pages/tbo/flight-history'));

// TBO Hotel
const TBOHotelSearch = lazy(() => import('./pages/tbo/hotel-search'));
const TBOHotelList = lazy(() => import('./pages/tbo/hotel-list'));
const TBOHotelDetails = lazy(() => import('./pages/tbo/hotel-details'));
const TBOGuestDetails = lazy(() => import('./pages/tbo/guest-details'));
const TBOHotelPayment = lazy(() => import('./pages/tbo/hotel-payment'));
const TBOHotelHistory = lazy(() => import('./pages/tbo/hotel-history'));

// TBO Shared
const TBOBookingConfirmation = lazy(() => import('./pages/tbo/booking-confirmation'));
const TBOPaymentCallback = lazy(() => import('./pages/tbo/payment-callback'));

// Marketplace
const MarketplaceHome = lazy(() => import('./pages/marketplace/MarketplaceHome'));
const MarketplaceCategory = lazy(() => import('./pages/marketplace/MarketplaceCategory'));
const MarketplaceProductDetail = lazy(() => import('./pages/marketplace/MarketplaceProductDetail'));
const MarketplaceCart = lazy(() => import('./pages/marketplace/MarketplaceCart'));
const MarketplaceOrders = lazy(() => import('./pages/marketplace/MarketplaceOrders'));
const MarketplaceVendorProducts = lazy(() => import('./pages/marketplace/MarketplaceVendorProducts'));

// Static Pages
const ContactUs = lazy(() => import('./pages/contact-us'));
const Disclaimer = lazy(() => import('./pages/static-page/disclaimer'));

const GOOGLE_MAPS_LIBRARIES = ['places'];

const App = () => {
  const { setCurrentUser } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    //! Dispatching API For Getting Customer Details
    const localUserId = localStorage.getItem(userId);

    const payload = {
      setCurrentUserData: (data) => setCurrentUser(data)
    };


    localUserId && dispatch(AuthActions.getCustomerDetails(payload));

    dispatch(SancharActions?.getCategory());
  }, [dispatch, navigate]);

  return (
    <>
      <AutoTranslator />

      {/* {location.pathname == '/milan-sathi' ? <MilanSathiHeader /> : < Header />} */}
      {location.pathname.startsWith('/milan-sathi') ? <MilanSathiHeader /> : <Header />}

      <LoadScript googleMapsApiKey={google_map_api_keys} libraries={GOOGLE_MAPS_LIBRARIES} loadingElement={<Loading />}>
        <Suspense fallback={<Loading />}>
          < Breadcrumbs />
          <ScrollToTop>
            <Routes>
              <Route path='/custom-login' element={<CustomLogin />} />
              <Route path='/coming-soon' element={<ComingSoon />} />
              <Route path='/profile' element={<BharatDarshanProfile />} />

              {/* History */}
              <Route path='/history/recharge-history' element={<RechargeHistory />} />
              <Route path='/history/product-history' element={<ProductHistory />} />
              <Route path='/history/puja-history' element={<PujaHistory />} />
              <Route path='/history/yatra-history' element={<YatraHistory />} />
              <Route path='/history/pitr-paksha-history' element={<PitrPakshaHistory />} />
              <Route path='/history/newyatra-history' element={<NewYatraHistory />} />

              <Route path='/' element={<LandingPage />} />
              <Route path='/home/form-data' element={<Formdata />} />
              <Route path='/vsscm' element={<Vsscm />} />

              <Route path='/flights-booking' element={<FlightsBooking />} />
              <Route path='/mobile' element={<Mobile />} />
              <Route path='/recharge' element={<Recharge />} />

              {/* Sanchar */}
              <Route path='/sanchar/podcast' element={<SancharPodcast />} />
              <Route path='/sanchar/podcast/podcast-data' element={<SancharPodcastdata />} />
              <Route path='/sanchar/video' element={<SancharVideo />} />
              <Route path='/sanchar/video/video-data' element={<SancharVideodata />} />
              <Route path='/sanchar/live' element={<SancharLive />} />
              <Route path='/sanchar/live/live-details' element={<SancharLiveDetails />} />
              <Route path='/sanchar/news' element={<SancharNews />} />
              <Route path='/sanchar/news/news-details' element={<SancharNewsDetails />} />

              {/* Religious */}
              <Route path='/religious/daily-darshan' element={<DailyDarshan />} />
              <Route path='/religious/consultancy' element={<Consultancy />} />

              {/* Yatra */}
              <Route path='/yatra' element={<Navigate to='/new-yatra' replace />} />
              <Route path='/yatra/yatra-child' element={<YatraChild />} />
              <Route path='/yatra/yatra-details' element={<YatraDetails />} />

              {/* New Yatra */}
              <Route path='/new-yatra' element={<NewYatraList />} />
              <Route path='/new-yatra/details/:id' element={<NewYatraDetails />} />
              <Route path='/new-yatra/package/:id' element={<NewYatraPackage />} />
              <Route path='/new-yatra/vehicle/:id' element={<NewYatraVehicle />} />
              <Route path='/new-yatra/booking/:vehicleId' element={<NewYatraBooking />} />
              <Route path='/new-yatra/payment-success' element={<NewYatraPaymentSuccess />} />
              <Route path='/new-yatra/payment-failed' element={<NewYatraPaymentFailed />} />

              {/* Products */}
              <Route path='/products' element={<Products />} />
              <Route path='/products/product-details' element={<ProductDetails />} />

              {/* Puja */}
              <Route path='/puja' element={<Puja />} />
              <Route path='/puja/puja-details' element={<PujaDetails />} />

              {/* Cart browse (no auth needed) */}
              <Route path='/cart/products-cart' element={<ProductsCart />} />

              {/* Milan Sathi Old */}
              <Route path="/verify-email" element={<VerifyEmailPage />} />

              {/* Milan Sathi New */}
              <Route path="/milan-sathi" element={<MilanSathi />} />
              <Route path="/milan-sathi/search" element={<Search />} />
              <Route path="/milan-sathi/search/profile/:id" element={<Profile />} />
              <Route path="/milan-sathi/membership" element={<Membership />} />

              {/* TBO browse routes (no auth) */}
              <Route path="/tbo/flight-search" element={<TBOFlightSearch />} />
              <Route path="/tbo/flight-list" element={<TBOFlightList />} />
              <Route path="/tbo/flight-details" element={<TBOFlightDetails />} />
              <Route path="/tbo/hotel-search" element={<TBOHotelSearch />} />
              <Route path="/tbo/hotel-list" element={<TBOHotelList />} />
              <Route path="/tbo/hotel-details" element={<TBOHotelDetails />} />

              {/* Marketplace browse (no auth) */}
              <Route path="/marketplace" element={<MarketplaceHome />} />
              <Route path="/marketplace/category/:categoryId" element={<MarketplaceCategory />} />
              <Route path="/marketplace/vendor/:vendorId" element={<MarketplaceVendorProducts />} />
              <Route path="/marketplace/product/:productId" element={<MarketplaceProductDetail />} />

              {/* === AUTH REQUIRED ROUTES === */}
              <Route element={<ProtectedRoute />}>
                {/* Milan Sathi dashboard */}
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/dashboard/edit-profile" element={<EditProfile />} />
                <Route path="/dashboard/connections" element={<Connections />} />
                <Route path="/dashboard/messages" element={<Messages />} />
                <Route path="/dashboard/messages/conversation/:id" element={<Conversations />} />
                <Route path="/dashboard/notifications" element={<Notifications />} />
                <Route path="/dashboard/verification" element={<Verification />} />
                <Route path="/dashboard/transactions" element={<Transactions />} />
                <Route path="/milan-sathi/checkout/:planId" element={<Checkout />} />

                {/* Booking / payment pages */}
                <Route path='/yatra/yatra-details/book-yatra' element={<BookYatra />} />
                <Route path='/puja/puja-details/book-puja' element={<BookPuja />} />
                <Route path='/cart/products-cart/address' element={<Address />} />
                <Route path='/marketplace/cart/address' element={<Address />} />
                <Route path="/marketplace/cart" element={<MarketplaceCart />} />
                <Route path="/marketplace/orders" element={<MarketplaceOrders />} />

                {/* TBO booking / payment pages */}
                <Route path="/tbo/passenger-details" element={<TBOPassengerDetails />} />
                <Route path="/tbo/flight-payment" element={<TBOFlightPayment />} />
                <Route path="/tbo/flight-history" element={<TBOFlightHistory />} />
                <Route path="/tbo/guest-details" element={<TBOGuestDetails />} />
                <Route path="/tbo/hotel-payment" element={<TBOHotelPayment />} />
                <Route path="/tbo/hotel-history" element={<TBOHotelHistory />} />
                <Route path="/tbo/booking-confirmation" element={<TBOBookingConfirmation />} />
              </Route>

              {/* Payment callbacks (no auth — PayU/Razorpay redirects here) */}
              <Route path='/payment-success' element={<PaymentStatus />} />
              <Route path='/payment-failure' element={<PaymentStatus />} />
              <Route path='/payu-success' element={<PaymentStatus />} />
              <Route path='/payu-failure' element={<PaymentStatus />} />
              <Route path="/tbo/payment-callback" element={<TBOPaymentCallback />} />

              {/* Static Pages */}
              <Route path="/terms-of-use" element={<TermsOfUse />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/refund-policy" element={<RefundPolicy />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/disclaimer" element={<Disclaimer />} />
              <Route path="/contact-us" element={<ContactUs />} />
            </Routes>
          </ScrollToTop>
        </Suspense >
        <ToastContainer />
      </LoadScript>

      {!useMatch('/dashboard/messages/conversation/:id') && <Footer />}
      <DownloadApp />
      <LoginModal />
      <SignupModal />
    </>
  )
};

export default App;